export class ListInventoryResourceGroupsResponse {
    'resourceGroups';
    'pagination';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceGroups",
            "baseName": "resourceGroups",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListInventoryResourceGroupsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
